import { isCoordinateLocation } from '../realtime/contracts';
import type { IncidentListItem, PortalCoordinateLocation } from '../realtime/contracts';

export type IncidentListRow = {
  id: string;
  title: string;
  purpose: IncidentListItem['purpose'];
  createdTimeUtc: string;
  lastPosition: PortalCoordinateLocation | null;
  isPositionRedacted: boolean;
  agencyNames: readonly string[];
  incidentLabel: string | null;
};

export function toRow(item: IncidentListItem): IncidentListRow {
  const position = item.lastPosition;
  const coordinates = position != null && isCoordinateLocation(position) ? position : null;

  return {
    id: item.id,
    title: item.title,
    purpose: item.purpose,
    createdTimeUtc: item.createdTimeUtc,
    lastPosition: coordinates,
    isPositionRedacted: position != null && coordinates === null,
    agencyNames: item.involvedAgencies.filter((agency) => agency.isActive).map((agency) => agency.displayName),
    incidentLabel: item.additionalIncidentData.incidentLabel,
  };
}
